const items = [
  "Geleceği Şekillendiren KOBİ'ler İçin Dijital Dönüşüm",
  "Ücretsiz Ön Analiz",
  "Stratejik Büyüme Yol Haritası",
  "%100 Hibrit Çözümler",
  "Verimlilik & Süreç Optimizasyonu",
];

export default function Marquee() {
  const content = [...items, ...items];
  return (
    <div className="bg-[#0B192C] text-[#CBD5E1] py-4 border-y border-[#1E293B] overflow-hidden" data-testid="editorial-marquee">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {content.map((item, i) => (
          <span key={i} className="font-mono text-xs sm:text-sm tracking-[0.2em] uppercase flex items-center">
            <span className="px-6">{item}</span>
            <span className="text-[#2563EB]">•</span>
          </span>
        ))}
      </div>
    </div>
  );
}
